import React from 'react';
import { Helmet } from 'react-helmet-async';
import Banner from "../Banner/Banner";
import Footer from "../Footer/Footer";
import GuideForContact from "./GuideForContact";
import ContactForm from "./ContactForm";

function Index(props) {
    return (
        <div>
            <Helmet defer={false}>
                <title>Contact Us | Love Your Feet Podiatry, North Shore Auckland</title>
                <meta
                    name="description"
                    content="Call 021 160 3227 or email us to ask about foot care, appointments or retirement village visits."
                />
                <link rel="canonical" href="https://loveyourfeet.co.nz/contactus" />
            </Helmet>
            <Banner />
            <GuideForContact />
            <ContactForm />
            <Footer />
        </div>
    );
}

export default Index;